import { render, staticRenderFns } from "./TableTree.vue?vue&type=template&id=baa72a4a&lang=pug&"
import script from "./TableTree.vue?vue&type=script&lang=js&"
export * from "./TableTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports